<flex-row style="padding: 40px; flex-wrap: wrap">
  <!-- dynamic contentful services! -->
  @for (service of content.content.services; track service) {
    @if (service.fields.productionReadiness || app.environment.frontend === 'dev' || app.environment.frontend === 'staging') {
      <div-relative
        class="card"
        [routerLink]="[isPublic ? '/service/store' : '/services/store', service.fields.urlSlug]"
        style="margin-right: 20px; border-radius: 5px; margin-top: 20px">
        <div
          style="
            z-index: 0;
            background-size: cover;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 200px;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
          "
          [style.background-image]="'url(' + service.fields.heroImage.fields.file.url + ')'"></div>
        <flex-row-center style="z-index: 1; position: relative">
          <!-- icon -->
          <flex-col-center-center
            style="margin-top: 100px; z-index: 1; width: 60px; height: 60px; padding: 30px; border-radius: 100%; border: 1px solid #333; background: #efefef">
            <img [src]="service.fields.icon.fields.file.url" />
          </flex-col-center-center>
        </flex-row-center>
        <!-- service name -->
        <flex-row-center class="semibold" style="position: relative; z-index: 1; font-size: 20px; margin: 15px 0">
          {{ service.fields.name | translate }}
        </flex-row-center>
        <!-- price -->
        <flex-row-center style="position: relative; z-index: 1; font-size: 20px; font-weight: 300; color: #666">{{ service.fields.startsAt }}</flex-row-center>
        <!-- bullets -->
        <flex-col style="margin-top: 20px; position: relative">
          @for (bullet of service.fields.highlights; track bullet) {
            <flex-row style="padding: 10px 0">
              <pc-icon name="check" style="min-width: 20px; min-height: 20px; width: 20px; height: 20px; margin-right: 10px" color="#222"></pc-icon>
              <div>{{ bullet }}</div>
            </flex-row>
          }
        </flex-col>
      </div-relative>
    }
    <!-- end of card -->
  }
  @if (noServicesAvailable) {
    <flex-row-center> There are now services available for this organisation or user currently. </flex-row-center>
  }
</flex-row>
